import { useClient } from '../../../catalogo/hooks/useClient';
import { useCodPostal } from '../../hooks/useCodPostal';
import { useDenoCondicionFiscal } from '../../hooks/useDenoCondicionFiscal';

export const Header = () => {
  const { data: dataClient } = useClient();

  const {
    codigoPostal,
    cuit,
    denominacion,
    domicilio,
    telefonos,
    idCondicionFiscal,
  } = dataClient || {};

  const CondFis = useDenoCondicionFiscal(idCondicionFiscal);
  const CodPostal = useCodPostal(codigoPostal);

  let cuitFormat = cuit;

  if (cuitFormat === undefined) cuitFormat = 'xx-xxxxxxxx-x';

  let codPostalSub = '';
  let ciudadSub = '';

  if (CodPostal.denominacion) {
    codPostalSub = CodPostal.denominacion.substring(0, 6);
    ciudadSub = CodPostal.denominacion.substring(6);
  }

  const formatCuit = (cuitFormat) => {
    let cuitFormateado = '';
    if (cuitFormat.length !== 11) {
      cuitFormateado = 'xx-xxxxxxxx-x';
    } else {
      const primeraParte = cuit.substring(0, 2); // Obtener las partes del CUIT
      const segundaParte = cuit.substring(2, 10);
      const terceraParte = cuit.substring(10);
      cuitFormateado = `${primeraParte}-${segundaParte}-${terceraParte}`; // Concatenar las partes con guiones
    }
    return cuitFormateado; // Devuelve el CUIT formateado
  };

  const renderCondFis = () => {
    if (CondFis === 'cargando') {
      return <p>Cargando condición fiscal...</p>;
    } else {
      return <p>I.V.A.: {CondFis}</p>;
    }
  };

  return (
    <article className="cardMembrete">
      <header>
        <h1 className="tituloMembrete">{denominacion}</h1>
      </header>
      <div className="bodyMembrete">
        <div className="columnasInfoMembrete">
          {renderCondFis()}
          <p>C.U.I.T.: {formatCuit(cuitFormat)} </p>
        </div>
        <div className="columnasInfoMembrete">
          <p>Dirección: {domicilio} </p>
          <p>Ciudad: {ciudadSub} </p>
        </div>
        <div className="columnasInfoMembrete">
          <p>C.P.: {codPostalSub}</p>
          <p>Tel.:{telefonos}</p>
        </div>
      </div>
    </article>
  );
};
